const isIOS = ()=> {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) 
  || navigator.platform === "MacIntel";
}

export default isIOS;